<template>
  <div class="flex-between desc">
    <div class="editor-sub-header-title">
      <span class="bold-text" v-if="info.company">{{info.company}}&nbsp;</span>
      <span class="bold-text" v-else-if="info.name">{{info.name}}&nbsp;</span>
      <span class="bold-text" v-else-if="info.university">{{info.university}}&nbsp;</span>
      <span class="bold-text" v-if="cv.format_info.punctuation_format === 'show_punctuation' && section !== 'personal_summary' && section !== 'skill_list'"> - </span>
      <span class="bold-text" v-if="info.major">{{info.major}}&nbsp;</span>
      <span class="bold-text" v-if="info.degree">{{info.degree}}&nbsp;</span>
      <span class="bold-text" v-if="info.uni_school">{{info.uni_school}}&nbsp;</span>
      <span class="bold-text" v-if="info.title">{{info.title}}&nbsp;</span>
      <span class="bold-text" v-if="info.dept">{{info.dept}}&nbsp;</span>
    </div>
    <div class="editor-sub-header-title">
      <span v-if="info.start_at">{{info.start_at | timeFilter(cv.format_info, cv.basic_info)}}</span>
      <span v-if="info.start_at && (info.end_at || info.present)"> - </span>
      <span v-if="info.end_at">{{info.end_at | timeFilter(cv.format_info, cv.basic_info)}}</span>
      <span v-if="info.present">{{info.present}}</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
let moment = require('moment')
export default {
  props: {
    info: {
      type: Object,
      default: () => {
        return {}
      }
    },
    section: {
    	type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  mounted () { },
	filters: {
		timeFilter: (val, format, basic) => {
			if (format.time_format === 'number') {
				return moment(val).format('YYYY.MM')
			} else {
				if (basic.lang === 'en') {
					return moment(val).format('MMM YYYY')
				} else {
					return moment(val).format('YYYY年MM月')
				}
			}
		}
	},
  components: {},
  watch: {},
  computed: {
    ...mapState('cv', ['cv'])
  },
  methods: {}
}
</script>
<style scoped lang="scss">
.bold-text {
  font-weight: 800;
  color: #000;
}
</style>
